export default function Register() {
    return(
        <>
        This is rego
        </>
    )
}